import React from 'react'
import { connect } from 'react-redux'
import { injectIntl, FormattedMessage } from 'react-intl'
import { compose, withHandlers, withState, lifecycle } from 'recompose'

import { requestCode, confirmCode, attachLogin } from '../../store/reducers/login'
import { addEmail } from '../../store/reducers/auth.js'

import Form from './../Form'
import Timer from '../../components/SIgn/Timer'
import { checkLogin, checkEmail } from '../../containers/Signin'

const LoginEdit = ({ state, error, intl, data, clearData, onSuccess, mode, setData, disabled, attachLogin, addEmail, requestCode, confirmCode, loginId }) => (
  <div>
    {mode === 'editEmail' && <Form placeholder={intl.formatMessage({id: 'profile_edit.email'})} value={data.email} onInput={setData('email')} onSubmit={addEmail} disableBtn={disabled} />}
    {state === 'init' && mode !== 'editEmail' && <Form placeholder={intl.formatMessage({id: 'sign_in.phone_or_mail'})} value={data.login} onInput={setData('login')} onSubmit={attachLogin} disableBtn={disabled} />}
    {state === 'confirm' && <Form placeholder={intl.formatMessage({id: 'sign_in.confirmation_code'})} value={data.code} onInput={setData('code')} onSubmit={confirmCode} />}

    <div className='Signin__actions'>
      {error && <div className='Text'>{error}</div>}
      {(state === 'confirm' && loginId) && <Timer noBack clear={clearData} sendCode={() => requestCode(loginId)} />}
    </div>

    {state !== 'confirm' && <div style={{ marginTop: '3.6603vw' }} />}
    <button className='Button Button_white' onClick={onSuccess}>
      <FormattedMessage id='timer.back' />
    </button>
  </div>
)

const mapState = ({ login }) => ({ ...login })

const mapDispatch = dispatch => ({
  confirmCode: code => dispatch(confirmCode(code)),
  attachLogin: login => dispatch(attachLogin(login)),
  addEmail: email => dispatch(addEmail(email)),
  requestCode: loginId => dispatch(requestCode(loginId))
})

export default compose(
  injectIntl,
  connect(mapState, mapDispatch),
  withState('disabled', 'setDisable', true),
  withState('data', 'setData', {}),
  withHandlers({
    setData: ({ data, setData, setDisable }) => field => value => {
      field === 'login' && setDisable(!checkLogin(value))
      field === 'email' && setDisable(!checkEmail(value))
      field === 'code' && setDisable(value.length < 4)

      setData({ ...data, [field]: value })
    },
    clearData: ({ setData }) => () => setData({}),
    attachLogin: ({ attachLogin, data, setData, setDisable }) => async e => {
      e && e.preventDefault()
      if (!data.login) return
      if (!checkLogin(data.login)) return

      const result = await attachLogin(data.login)

      if (result === 200) {
        setData({})
        setDisable(true)
      }
    },
    addEmail: ({ addEmail, data, onSuccess }) => async e => {
      e && e.preventDefault()
      if (!data.email) return
      if (!checkEmail(data.email)) return

      const result = await addEmail(data.email)
      if (result === 200) {
        onSuccess()
      }
    },
    confirmCode: ({ data, setData, confirmCode, loginId, onSuccess }) => async e => {
      e && e.preventDefault()
      if (!loginId) return
      if (!data.code) return
      if (data.code.length < 4) return

      const result = await confirmCode(loginId, data.code)
      if (result === 200 && onSuccess) onSuccess()
    }
  }),
  lifecycle({
    componentDidUpdate (pp) {
      if (!pp.loginId && this.props.loginId) this.props.requestCode(this.props.loginId)
    }
  })
)(LoginEdit)



// WEBPACK FOOTER //
// ./src/components/Profile/Login.jsx